import { observer } from 'mobx-react-lite'
import { Button, EmptyState } from 'shared/ui'
import { tooltipText } from 'shared/constants/tooltipText'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RoleUpgradeRequestModalStore } from 'entities/UsersPermissions'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'

export const EmptyStateCallHistory = observer(() => {
  const { callStore, featureFlagsStore, inboxesStore, usersStore } = useEntitiesContext()
  const { callModalStore } = useCallHistoryContext()
  const isPFTInbox = inboxesStore.currentInbox?.isPFTInbox
  const inteliquentCalling = featureFlagsStore.inteliquent_calling
  const phoneType = inboxesStore.nonPFTInboxNumberType
  const onClick = () => {
    if (usersStore.user?.isViewOnlyRole) {
      new RoleUpgradeRequestModalStore()
      return
    }
    callModalStore.openModal()
  }

  return (
    <EmptyState
      iconProps={{ icon: 'phone', color: 'var(--content-neutral-primary)' }}
      title={'Make your first call'}
      text={'Engage with your contacts'}
      actions={
        <Button
          text={'Make a call'}
          onClick={onClick}
          iconProps={{ icon: 'phone' }}
          size={'medium'}
          disabled={(isPFTInbox && !inteliquentCalling) || callStore.isBusy}
          tooltipProps={
            isPFTInbox && !inteliquentCalling
              ? {
                  label: tooltipText.disabledCall(phoneType),
                  placement: 'right',
                  fullWidth: true,
                }
              : undefined
          }
        />
      }
    />
  )
})
